import React from 'react';
import { useEffect } from 'react';

const Guarantee = () => {
    useEffect(() => {
        document.title = 'NASCAR — Гарантия';
    }, []);

    return <div className="page">
            <h2>ГАРАНТИЯ</h2>

            <ol>
                <li>Гарантийный срок на товар 1 (один) год с даты продажи.</li>
                <li>Гарантийный срок на аккумулятор составляет 6 (шесть) месяцев.</li>
                <li>Гарантийный срок на зарядное устройство составляет 1 (один) месяц (если идет в комплекте).</li>
            </ol>

            <p>Доставка товаров в сервисный центр для диагностики, сервисного обслуживания и ТО осуществляется за счет покупателя или по согласованию.</p>

            <p>Гарантия на изделие не распространяется в случае:</p>
            <ol>
                <li>Самостоятельной сборка, разборка, настройка, регулировка без согласования с сервисным центром.</li>
                <li>На изделии имеются следы механических, химических, термических повреждений, следы иных воздействий, не предусмотренных правилами эксплуатации изделия.</li>
                <li>Неисправность вызвана обстоятельствами непреодолимой силы (стихийное бедствие и т.п.).</li>
                <li>Допущено нарушение потребителем или третьими лицами правил эксплуатации, хранения и транспортировки изделия, включая использование изделия не по прямому назначению (в т.ч. в коммерческих и учебных целях, участие в соревнованиях), эксплуатацию изделия с нарушением правил и требований безопасности, небрежное или неосторожное обращение.</li>
                <li>Неисправность вызвана несанкционированными изменениями, в том числе изменением конструкции, модифицирование настроек компьютера, схемы изделия, разборкой или ремонтом, выполненным лицами, не являющимися сотрудниками уполномоченных сервисных центров или уполномоченными представителями компании производителя. При нарушении или отсутствии пломб, находящихся на корпусе изделия.</li>
                <li>Несанкционированные изменения иных составных частей и комплектующих изделия.</li>
                <li>Неисправность (повреждение) техники вызвано попаданием внутрь изделия посторонних предметов (ворс, песок, насекомое и др.), пыли, влаги, иных жидкостей и т.п., а также вызванная поездками в дождь или погружением в воду.</li>
                <li>Износ колодок, вследствие чрезмерной нагрузки.</li>
                <li>Нарушений правил эксплуатации, указанных в инструкции по эксплуатации.</li>
                <li>Субъективные ощущения водителя (вибрация, шум от двигателя и других механизмов).</li>
            </ol>

            <p>Настоящая гарантия составлена в соответствии с Законом Республики Беларусь о защите прав потребителя и не ограничивают права указанные в нем. Действительна при предъявлении оригинала настоящего гарантийного талона, заполненного надлежащим образом (указана модель, присутствует штамп продавца, дата продажи).</p>

    </div>;
};

export default Guarantee;
